export default "__VITE_ASSET__BPLxOKAE__"